<div class="row">
  <div class="col">
    <button class='btn btn-info' (click)='newContract()'>New Contract</button>
  </div>
</div>

<div class="bg-primary pb-3">
  <app-grid
    entity='contract'
    [filters]='this.contractFilters'
    [columns]='this.contractColumns'
    [buttons]='this.contractButtons'
    [searchFilters]='this.contractSearchFilters'
    [searchFields]='this.contractSearchFields'
  ></app-grid>
</div>
